import Client from '../HttpClient';

const baseUrl = `/gateway/wombat-mgt/api/vs/manage-cardSettle`;

const assign = (
	merchantId,
	branchId,
	codes,
	codeStart,
	codeEnd,
	inputType,
	operateBy
) => {
	return Client.post(`${baseUrl}/${merchantId}/cardSettleActivitys/assign`, {
		assignBranchId: branchId,
		cardCodes: codes,
		cardCodeStart: codeStart,
		cardCodeEnd: codeEnd,
		optionType: inputType,
		operateBy,
	});
};

const revoke = (
	merchantId,
	branchId,
	codes,
	codeStart,
	codeEnd,
	inputType,
	operateBy
) => {
	return Client.post(`${baseUrl}/${merchantId}/cardSettleActivitys/refund`, {
		unBindBranchId: branchId,
		cardCodes: codes,
		cardCodeStart: codeStart,
		cardCodeEnd: codeEnd,
		optionType: inputType,
		operateBy,
	});
};

export default { assign, revoke };
